import { Account } from 'api/Account/types';
import { createAccountRequest, changeAccountRequest } from 'api/Account/api';

import { useState, useMemo } from 'react';
import { useFormik } from 'formik';
import { useTranslation } from 'react-i18next';
import * as yup from 'yup';

export const useAccount = (onSuccessfulSubmit: (account: Account) => void, initialValues: Account | null) => {
  const { t } = useTranslation();

  const [ isSubmitting, setSubmitting ] = useState(false);
  const [ submitError, setSubmitError ] = useState<string>();

  const validationSchema = useMemo(() => yup.object({
    accountId: yup
      .string()
      .required('Enter an account id'),
    name: yup
      .string()
      .required('Enter a name'),
  }), []);

  const onSubmit = (account: Account) => {
    setSubmitting(true);
    setSubmitError('');

    const { id } = account;
    const callback = id === '' ? createAccountRequest : changeAccountRequest;

    callback(account)
      .then(({ data }) => {
        onSuccessfulSubmit(data);
      })
      .catch((error) => {
        setSubmitError(error?.response?.data?.message || t('errors.server_error_try_again'));
      })
      .finally(() => setSubmitting(false));
  };

  const initAccount = initialValues || {
    id: '',
    accountId: '',
    name: '',
    createdAt: '',
    updatedAt: '',
  };

  const formik = useFormik<Account>({
    initialValues: initAccount,
    validationSchema,
    onSubmit,
  });

  return { formik, isSubmitting, submitError };
};
